import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BeneficiaryService } from '../services/beneficiary.service';
import { CommonService } from '../services/common.service';
import { TransactionService } from '../services/transaction.service';

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.css']
})
export class TransactionComponent implements OnInit {

  sourceUrl

  constructor(public transactionService  : TransactionService, private common: CommonService, public beneficiaryService : BeneficiaryService, private router: Router, private route : ActivatedRoute) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.getSources()
      // this.getExchangeRate(this.source, this.beneficiaryService.selectedDestination?.name)
    }, 500);
  }

  async connectWallet(){
    // this.transactionService.isConnectedWallet = false
    this.transactionService.connectedWalletAddress = ''
    this.transactionService.balance = -1
    let address
    if(this.transactionService.selectedSource.wallet=='walletConnect'){
      address = await this.transactionService.connectWalletCusd()
    }
    else if(this.transactionService.selectedSource.wallet=='terraStation'){
      address = await this.transactionService.connectWalletTerra()
    }
    else if(this.transactionService.selectedSource.wallet=='near'){
      address = await this.transactionService.connectWalletNear()
    }
    if(address){
      this.transactionService.isConnectedWallet = true
      this.transactionService.connectedWalletAddress = address
      this.transactionService.connectedWalletAddressModified = address.slice(0,20)
      // this.checkBalance()
    }
  }

  async checkBalance(){
    if(this.transactionService.selectedSource.wallet=='walletConnect'){
      this.common.showLoader()
      this.transactionService.balance = await this.transactionService.getBalance(this.transactionService.connectedWalletAddress, this.transactionService.source)
      this.common.hideLoader()
    }
    else if(this.transactionService.selectedSource.wallet=='bnbClient'){
      this.common.showLoader()
      let walletBalance = await this.transactionService.getBalanceBinance()
      
      this.transactionService.balance = +walletBalance
      this.common.hideLoader()
    }
    else if(this.transactionService.selectedSource.wallet=='near'){
      this.common.showLoader()
      let nearBal = await this.transactionService.getNearBalance()
      this.transactionService.balance = +nearBal
      this.common.hideLoader()
    }
    this.transactionService.balance = Math.round(+this.transactionService.balance*100) / 100
    
  }

  changeDestinationAmount(){
    this.transactionService.convertedAmount = this.transactionService.sourceAmount * this.transactionService.conversionRate
    this.transactionService.convertedAmount = Math.round(+this.transactionService.convertedAmount*100) / 100
  }

  getFees(){
    this.common.getFees(this.transactionService.source, this.beneficiaryService.selectedDestination?.name).subscribe((res:any)=>{
      this.transactionService.fees = res[0]?.amount
    }, (err:any)=>{
      console.log(err)
    })
  }

  getSources(){
    this.common.showLoader()
    this.common.getAllSources().subscribe((res:any)=>{
      this.transactionService.sources = res.filter(source => source.state)
      // this.selectSource(res[3], res[3].image.url)
      this.route.queryParams.subscribe(async params => {
        const {account_id, all_keys} = params
        if(account_id && all_keys){
          this.selectSource(this.transactionService.sources.find(src => src.name.toLowerCase() === 'usn'), this.transactionService.sources.find(src => src.name.toLowerCase() === 'usn').image.url)
          let address = await this.transactionService.connectWalletNear()
          if(address){
            this.transactionService.isConnectedWallet = true
            this.transactionService.connectedWalletAddress = address
            this.transactionService.connectedWalletAddressModified = address.slice(0,20)
            this.checkBalance()
            document.getElementById('navbarNav').classList.remove('show')
          }
        }
      })
      this.common.hideLoader()
    },(err:any)=>{
      console.log(err)
      this.common.hideLoader()
    })
  }

  async selectSource(source, imageUrl){
    this.transactionService.selectedSource = source
    this.transactionService.source = source.name
    this.sourceUrl = imageUrl
    this.getFees()
    this.getExchangeRate(this.transactionService.source, this.beneficiaryService.selectedDestination?.name)

    if(this.transactionService.isConnectedWallet)
      await this.connectWallet()
    
    
    if(this.transactionService.connectedWalletAddress && this.transactionService.selectedSource.wallet=='walletConnect')
      this.checkBalance()
    
  }

  getExchangeRate(source, destination){

    if(source && destination){
      this.common.getExchangeRate(source, destination).subscribe((res:any)=>{
        this.transactionService.conversionRate = res[0].rate
        this.changeDestinationAmount()
      }, (err:any)=>{
        console.log(err)
      })
    }
    
  }

  async createTransaction(){
    this.transactionService.transactionInitiated = true
    this.common.showLoader()
    this.transactionService.getToAddress().subscribe(async (res:any)=>{
      if(res.length==0){
        this.common.hideLoader()
        this.transactionService.transactionInitiated = false
        alert("transaction failed")
      }
      else{
        this.transactionService.toAddress = res[0].address
        //initiate transaction here
        let transactionObject = {
          fromAddress: this.transactionService.connectedWalletAddress,
          sourceCurrency: this.transactionService.selectedSource.id,
          destinationCurrency: this.beneficiaryService.selectedDestination.id,
          destinationAmount: this.transactionService.convertedAmount,
          sourceAmount: this.transactionService.sourceAmount,
          benificiary: this.beneficiaryService.selectedBeneficiary.id,
          fees: this.transactionService.fees
        }

        if(+this.transactionService.fees + +this.transactionService.sourceAmount > +this.transactionService.balance){
          alert("You dont have sufficient funds in your wallet.")
          this.common.hideLoader()
          this.transactionService.transactionInitiated = false
          this.transactionService.gasFeesError = false
        }
        else if(+this.transactionService.fees + +this.transactionService.sourceAmount == +this.transactionService.balance){
          this.transactionService.gasFeesError = true
          this.common.hideLoader()
          this.transactionService.transactionInitiated = false
        }
        else{
          this.transactionService.sendTransaction(transactionObject).subscribe(async (res:any)=>{
            this.transactionService.transactionId = res.id
            if(this.transactionService.selectedSource.wallet=='walletConnect'){
              //for celo
              let reciept = await this.transactionService.createTransaction(+this.transactionService.sourceAmount + +this.transactionService.fees)
              console.log(reciept)
              if(!reciept){
                console.log("false1")
                this.common.hideLoader()
                this.transactionService.transactionInitiated = false
                this.transactionService.gasFeesError = false
                alert("transaction failed")
              }
              else{
                //post transaction here
                let postTransactionObj = {
                  id: this.transactionService.transactionId,
                  txnHash: reciept.transactionHash,
                  fromAddress: this.transactionService.connectedWalletAddress
                }
                this.transactionService.updateTransaction(postTransactionObj).subscribe((res:any)=>{
                  this.common.hideLoader()
                  this.transactionService.convertedAmount = 0
                  this.transactionService.sourceAmount = 0
                  this.checkBalance()
                  this.beneficiaryService.selectedBeneficiary = ''
                  alert("transaction success")
                }, (err:any)=>{
                  alert("transaction failed")
                  this.common.hideLoader()
                })
                this.transactionService.gasFeesError = true
                this.transactionService.transactionInitiated = false
              }
            }
            else if(this.transactionService.selectedSource.wallet=='terraStation'){
              await this.transactionService.createTransactionTerra(this.transactionService.sourceAmount +this.transactionService.fees)
            }
            else if(this.transactionService.selectedSource.wallet=='bnbClient'){
              let reciept = await this.transactionService.createTransactionBinance(+this.transactionService.sourceAmount + +this.transactionService.fees)
              console.log(reciept)
              let postTransactionObj = {
                id: this.transactionService.transactionId,
                txnHash: reciept.transactionHash,
                fromAddress: this.transactionService.connectedWalletAddress
              }
              this.transactionService.updateTransaction(postTransactionObj).subscribe((res:any)=>{
                this.common.hideLoader()
                this.transactionService.convertedAmount = 0
                this.transactionService.sourceAmount = 0
                this.checkBalance()
                this.beneficiaryService.selectedBeneficiary = ''
                alert("transaction success")
              }, (err:any)=>{
                alert("transaction failed")
                this.common.hideLoader()
              })
              this.transactionService.gasFeesError = false
              this.transactionService.transactionInitiated = false
            }
            else if(this.transactionService.selectedSource.wallet=='near'){
              let receipt = await this.transactionService.createTransactionNear(+this.transactionService.sourceAmount + +this.transactionService.fees, this.transactionService.transactionId)
              this.common.hideLoader()
            }
          }, (err:any)=>{
            alert("transaction failed")
            this.transactionService.gasFeesError = false
            this.transactionService.transactionInitiated = false
            this.common.hideLoader()
          })
        }

        
        
        
      }
      
      
    }, (err:any)=>{
      console.log(err)
    })
    
  }

  async disconnectWallet(){
    this.common.showLoader()
    await this.transactionService.disconnectWallet()
    this.common.hideLoader()
  }

  transactionWithinLimits(){
    if(
      +this.transactionService.convertedAmount >= +this.transactionService.lower_limit 
      &&
      +this.transactionService.convertedAmount <= +this.transactionService.upper_limit
    ){
      return true
    }
    else{
      return false
    }
  }
}
